export default "__VITE_ASSET__$yiN5xrA__"